module.exports = __webpack_public_path__ + "img/UTGREA-6.78bb4646.jpg";